import type { OralExamIntegrityBudget } from '@/common/api/models/oralExamIntegrityBudget';

/** Seconds shown on the pause banner — the tighter of consecutive and total remaining. */
export function integrityBudgetPauseRemainingSeconds(
  budget?: Pick<OralExamIntegrityBudget, 'remainingConsecutiveSeconds' | 'remainingTotalSeconds'> | null,
): number | undefined {
  const consecutive = budget?.remainingConsecutiveSeconds;
  const total = budget?.remainingTotalSeconds;
  if (consecutive != null && total != null) {
    return Math.min(consecutive, total);
  }
  return consecutive ?? total ?? undefined;
}
